import React from 'react';

export const MarkdownLineBreak = () => <br />;
